// extracted by mini-css-extract-plugin
module.exports =  {"ProductDetail":"ProductDetail__ie8ra"};